import React, { useContext, useEffect, useState } from "react";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import {
  SideMenuItems,
  HTTPResponse,
  ToastMessageType,
  ToastMessages,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";

import ErrorField from "../../Components/ErrorField";
import {
  CommonError_Msgs,
  EligibilityCriteria_Msgs,
  hyperlinkTextS11,
} from "../../Helpers/HelperText";

import InfoPopUp from "../../Components/InfoPopUp";
import { AppContext } from "../../Contexts/AppContextProvider";
import {
  GetLocalStorageData,
  GetLoggedInUserID,
  AddLocalStorageData,
  checkEligibileCohortTreatment,
  isStringEmpty,
  IsAdmin,
  IsLessOrEqual,
  CalculateAge,
} from "../../Helpers/Utilities";
import DatePickerComponent from "../../Components/DatePickerComponent";
import dayjs from "dayjs";
import { EligibilityCriteriaService } from "../../WebApiServices/EligibilityCriteria.service";

const RRMMCriteria = () => {
  const [tecvayli_s11, setTecyali_s11] = useState();
  const [talvey_s11, setTalvey_s11] = useState();
  const [elrexfio_s11, setElrexfio_s11] = useState();
  const [linvoseltamab_s11, setLinvoseltamab_s11] = useState();
  const [carvykti_s11, setCarvykti_s11] = useState();
  const [abecma_s11, setAbecma_s11] = useState();
  const [isEligible, setIsEligible] = useState(false);
  const [isAllDataFilled, setIsAllDataFilled] = useState(false);

  const [showHideHyperlinkModalS11, setShowHideHyperlinkModalS11] =
    useState(false);
  const [isNewEcrfA, setIsNewEcrfA] = useState(false);

  const pid = GetLocalStorageData("patientId") ?? 0;
  let patientData = GetLocalStorageData("patient");
  patientData = patientData && JSON.parse(patientData);
  const eligibilityCriteriaLocked =
    patientData?.eligibilityCriteriaLocked ?? false;

  const centerId = patientData?.ptCenterId ?? 0;
  const surveyDate = patientData?.surveyDate ?? "";
  const {
    ShowToast,
    ToggleLoader,
    ShowActionPopUp,
    HandleSessionTimeout,
    isSideMenuActive,
    setIsSideMenuActive,
    patientConfigData,
  } = useContext(AppContext);
  const terminatedPageId = patientConfigData?.data?.terminatedPageId;

  const HasEligibleNonNdmmNonMonoTherapyCohort = () => {
    const storedData = GetLocalStorageData("CohortTreatment");
    if (!storedData) return false;

    const cohortTreatmentList = JSON.parse(storedData);

    return cohortTreatmentList.some(
      (cohort) =>
        cohort.isEligible === true &&
        cohort.ndmm !== true &&
        cohort.monoTherapyReceived === false,
    );
  };

  const navigatePaths = {
    prevPage: "/NDMMCriteria",
    currPage: "/RRMMCriteria",
    nextPage:
      terminatedPageId === SideMenuItems.RRMMCriteria
        ? "/ManagePatients"
        : isNewEcrfA && HasEligibleNonNdmmNonMonoTherapyCohort()
          ? "/RRMMComboTherapy"
          : eligibilityCriteriaLocked
            ? "/ExclusionCriteria"
            : isAllDataFilled && isEligible
              ? "/ExclusionCriteria"
              : isAllDataFilled && !isEligible
                ? "/ManagePatients"
                : "/RRMMCriteria",
  };

  const S11_COHORT_CONFIG = {
    TECVAYLI: {
      checkboxField: "S11_RRMM_TECVAYLI",
      rbField: "S11_RRMM_TECVAYLI_rb",
      indexDateField: "S11_TECVAYLI_Date",
      terminateField: "s11TecTerminate",
      fdaApprovalDate: "2022/10/25",
      rdField: "S11_RRMM_TECVAYLI_RD",
      validateAge: false,
    },
    TALVEY: {
      checkboxField: "S11_RRMM_TALVEYTM",
      rbField: "S11_RRMM_TALVEYTM_rb",
      indexDateField: "S11_TALVEYTM_Date",
      terminateField: "s11TalTerminate",
      fdaApprovalDate: "2023/08/09",
      rdField: "S11_RRMM_TALVEYTM_RD",
      validateAge: false,
    },
    ELREXFIO: {
      checkboxField: "S11_RRMM_ELREXFIOTM",
      rbField: "S11_RRMM_ELREXFIOTM_rb",
      indexDateField: "S11_ELREXFIOTM_Date",
      terminateField: "s11ElrTerminate",
      fdaApprovalDate: "2023/08/14",
      rdField: "S11_RRMM_ELREXFIOTM_RD",
      validateAge: false,
    },
    LINVOSELTAMAB: {
      checkboxField: "S11_RRMM_Linvoseltamab",
      rbField: "S11_RRMM_Linvoseltamab_rb",
      indexDateField: "S11_Linvoseltamab_Date",
      terminateField: "s11LinTerminate",
      fdaApprovalDate: "2024/09/20",
      rdField: "S11_RRMM_Linvoseltamab_RD",
      validateAge: false,
    },
    CARVYKTI: {
      checkboxField: "S11_RRMM_CARVYKTI",
      rbField: "S11_RRMM_CARVYKTI_rb",
      indexDateField: "S11_CARVYKTI_Date",
      terminateField: "s11CarTerminate",
      fdaApprovalDate: "2022/02/28",
      rdField: "S11_RRMM_CARVYKTI_RD",
      validateAge: true,
    },
    ABECMA: {
      checkboxField: "S11_RRMM_ABECMA",
      rbField: "S11_RRMM_ABECMA_rb",
      indexDateField: "S11_ABECMA_Date",
      terminateField: "s11AbeTerminate",
      fdaApprovalDate: "2021/03/26",
      rdField: "S11_RRMM_ABECMA_RD",
      validateAge: true,
    },
  };

  useEffect(() => {
    async function FetchData() {
      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
    // ShowPopup();
  }, []);

  const [criteriaRRMM, setCriteriaRRMM] = useState({
    userId: GetLoggedInUserID(),

    //endofFollowUpDate: "",
    lastPatientEncounter: "",
    S11_RRMM_TECVAYLI: false,
    S11_RRMM_TALVEYTM: false,
    S11_RRMM_ELREXFIOTM: false,
    S11_RRMM_Linvoseltamab: false,
    S11_RRMM_CARVYKTI: false,
    S11_RRMM_ABECMA: false,
    S11_RRMM_NOTA: null,

    //S11 radio buttons
    S11_RRMM_TECVAYLI_rb: null,
    S11_RRMM_TALVEYTM_rb: null,
    S11_RRMM_ELREXFIOTM_rb: null,
    S11_RRMM_Linvoseltamab_rb: null,
    S11_RRMM_CARVYKTI_rb: null,
    S11_RRMM_ABECMA_rb: null,

    S11_RRMM_TECVAYLI_RD: null,
    S11_TECVAYLI_Date: "",
    S11_RRMM_TALVEYTM_RD: null,
    S11_TALVEYTM_Date: "",
    S11_RRMM_ELREXFIOTM_RD: null,
    S11_Linvoseltamab_Date: "",
    S11_RRMM_Linvoseltamab_RD: null,
    S11_RRMM_CARVYKTI_RD: null,
    S11_CARVYKTI_Date: "",
    S11_RRMM_ABECMA_RD: null,
    S11_ABECMA_Date: "",
    metInclusionCriteria: null,
    eligibilityDisabled: false,
    s4_birth_date: null,
    s4_MM_diagnosis_date: null,
    initiationDate1LTreatment: null,

    S11_TECVAYLI_Date_ValidError: false,
    S11_TALVEYTM_Date_ValidError: false,
    S11_ELREXFIOTM_Date_ValidError: false,
    S11_Linvoseltamab_Date_ValidError: false,
    S11_CARVYKTI_Date_ValidError: false,
    S11_ABECMA_Date_ValidError: false,
  });

  const [showTopErrMsg, setShowTopErrMsg] = useState(false);

  const InitialHardErrList = {
    s11Empty: false,
    s11EmptyDate: false,
    s11TecInvalidDate: false,
    s11TalInvalidDate: false,
    s11ElrInvalidDate: false,
    s11LinInvalidDate: false,
    s11CarInvalidDate: false,
    s11AbeInvalidDate: false,

    // radio (monotherapy / combination) validation per drug
    s11TecRb: false,
    s11TalRb: false,
    s11ElrRb: false,
    s11LinRb: false,
    s11CarRb: false,
    s11AbeRb: false,
  };
  const [hardErrList, setHardErrList] = useState(InitialHardErrList);
  const InitialSoftErrList = {
    s11Terminate: false,
    s11TecTerminate: false,
    s11TalTerminate: false,
    s11ElrTerminate: false,
    s11LinTerminate: false,
    s11CarTerminate: false,
    s11AbeTerminate: false,
    initiationDateInvalid: false,
    patientAgeError: false,
  };
  const [softErrList, setSoftErrList] = useState(InitialSoftErrList);

  async function LoadData() {
    try {
      if (pid > 0) {
        // Fetch data from the service
        const response = await EligibilityCriteriaService.LoadRRMMCriteria(pid);

        if (response?.status === HTTPResponse.OK) {
          const data = response.data;

          setIsNewEcrfA(data.isNewEcrfA ?? false);
          // Update the state with the fetched data
          const nextCriteriaRRMM = {
            // endofFollowUpDate: data.endofFollowUpDate,
            lastPatientEncounter: data.lastPatientEncounterDate,
            eligibilityDisabled: data.eligibilityLocked,
            S11_TECVAYLI_Date_ValidError: false,
            S11_TALVEYTM_Date_ValidError: false,
            S11_ELREXFIOTM_Date_ValidError: false,
            S11_Linvoseltamab_Date_ValidError: false,
            S11_CARVYKTI_Date_ValidError: false,
            S11_ABECMA_Date_ValidError: false,

            S11_RRMM_TECVAYLI: data.cartTherapyTecvayli ?? false,
            S11_RRMM_TALVEYTM: data.cartTherapyTalvey ?? false,
            S11_RRMM_ELREXFIOTM: data.cartTherapyElrexfio ?? false,
            S11_RRMM_Linvoseltamab: data.cartTherapyLinvoseltamab ?? false,
            S11_RRMM_CARVYKTI: data.cartTherapyCarvykti ?? false,
            S11_RRMM_ABECMA: data.cartTherapyAbecma ?? false,
            S11_RRMM_NOTA:
              data.cartTherapyNone != null
                ? data.cartTherapyNone == true
                  ? 1
                  : 0
                : null,
            S11_TECVAYLI_Date: data.indexdateCartTherapyTecvayli
              ? data.indexdateCartTherapyTecvayli
              : null,
            S11_RRMM_TECVAYLI_RD: data.indexdateCartTherapyTecvayliUnk
              ? 99
              : data.indexdateCartTherapyTecvayli
                ? 1
                : null,

            S11_TALVEYTM_Date: data.indexdateCartTherapyTalvey
              ? data.indexdateCartTherapyTalvey
              : null,
            S11_RRMM_TALVEYTM_RD: data.indexdateCartTherapyTalveyUnk
              ? 99
              : data.indexdateCartTherapyTalvey
                ? 1
                : null,

            S11_ELREXFIOTM_Date: data.indexdateCartTherapyElrexfio
              ? data.indexdateCartTherapyElrexfio
              : null,
            S11_RRMM_ELREXFIOTM_RD: data.indexdateCartTherapyElrexfioUnk
              ? 99
              : data.indexdateCartTherapyElrexfio
                ? 1
                : null,

            S11_Linvoseltamab_Date: data.indexdateCartTherapyLinvoseltamab
              ? data.indexdateCartTherapyLinvoseltamab
              : null,
            S11_RRMM_Linvoseltamab_RD: data.indexdateCartTherapyLinvoseltamabUnk
              ? 99
              : data.indexdateCartTherapyLinvoseltamab
                ? 1
                : null,

            S11_CARVYKTI_Date: data.indexdateCartTherapyCarvykti
              ? data.indexdateCartTherapyCarvykti
              : null,
            S11_RRMM_CARVYKTI_RD: data.indexdateCartTherapyCarvyktiUnk
              ? 99
              : data.indexdateCartTherapyCarvykti
                ? 1
                : null,

            S11_ABECMA_Date: data.indexdateCartTherapyAbecma
              ? data.indexdateCartTherapyAbecma
              : null,
            S11_RRMM_ABECMA_RD: data.indexdateCartTherapyAbecmaUnk
              ? 99
              : data.indexdateCartTherapyAbecma
                ? 1
                : null,

            s4_birth_date: !isStringEmpty(data.birthDate)
              ? data.birthDate
              : null,
            s4_MM_diagnosis_date: !isStringEmpty(data.mmDiagnosisDate)
              ? data.mmDiagnosisDate
              : null,

            // metInclusionCriteria: data.metInclusionCriteria,

            initiationDate1LTreatment: data.initiationDate1LTreatment
              ? data.initiationDate1LTreatment
              : null,
            S11_RRMM_ABECMA_rb: data.abecmaReceived,
            S11_RRMM_TALVEYTM_rb: data.telveyReceived,
            S11_RRMM_CARVYKTI_rb: data.carvyktiReceived,
            S11_RRMM_TECVAYLI_rb: data.tecvayliReceived,
            S11_RRMM_ELREXFIOTM_rb: data.elrexfioReceived,
            S11_RRMM_Linvoseltamab_rb: data.lynozyficReceived,
          };
          setCriteriaRRMM((prev) => ({
            ...prev,
            ...nextCriteriaRRMM,
          }));

          if (data.cohortTreatmentModelList.length > 0)
            AddLocalStorageData(
              "CohortTreatment",
              JSON.stringify(data.cohortTreatmentModelList),
            );
          else AddLocalStorageData("CohortTreatment", JSON.stringify([]));

          // Compute cohort ineligibility for all cohorts on load

          const softErrUpdate = ComputeRRMMCohortSoftErrors(nextCriteriaRRMM);

          setSoftErrList((prev) => ({
            ...prev,
            ...softErrUpdate,
          }));
        } else if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  }

  const ComputeRRMMCohortSoftErrors = (criteria) => {
    const softErrUpdate = {};
    let initiationDateInvalid = false;
    let patientAgeError = false;

    Object.values(S11_COHORT_CONFIG)
      .filter((cohort) => criteria[cohort.checkboxField])
      .forEach((cohort) => {
        const cohortDate = criteria[cohort.indexDateField];
        const unknownFlag = criteria[cohort.rdField] === 99;
        let ineligible = false;
        if (unknownFlag === true) {
          ineligible = true;
        }
        // DATE VALIDATION
        else if (cohortDate) {
          ineligible = !IsCohortDateValid(
            criteria,
            cohortDate,
            cohort.fdaApprovalDate,
          );
        }
        let isAgeInvalid = false;
        const isMonotherapy = criteria[cohort.rbField] === 1;
        const shouldValidateAge =
          cohortDate && (cohort.validateAge || isMonotherapy);

        if (shouldValidateAge) {
          // AGE VALIDATION
          isAgeInvalid = ValidatePatientAgeForCohort(criteria, cohortDate);

          if (isAgeInvalid) patientAgeError = true;
        }

        if (ineligible) initiationDateInvalid = true;

        softErrUpdate[cohort.terminateField] = ineligible || isAgeInvalid;
      });

    // None of the above
    softErrUpdate.s11Terminate = criteria.S11_RRMM_NOTA === 1;

    softErrUpdate.initiationDateInvalid = initiationDateInvalid;
    softErrUpdate.patientAgeError = patientAgeError;

    return softErrUpdate;
  };

  const UpdateRRMMSoftErrors = (criteria) => {
    const softErrUpdate = ComputeRRMMCohortSoftErrors(criteria);
    setSoftErrList((prev) => ({
      ...prev,
      ...softErrUpdate,
    }));
  };

  const HandleFieldChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "S11_RRMM_NOTA": {
        const value_int = Number(value);

        if (value_int === 1) {
          setCriteriaRRMM((prev) => {
            const next = {
              ...prev,
              [name]: value_int,
              S11_RRMM_TECVAYLI: false,
              S11_RRMM_TALVEYTM: false,
              S11_RRMM_ELREXFIOTM: false,
              S11_RRMM_Linvoseltamab: false,
              S11_RRMM_CARVYKTI: false,
              S11_RRMM_ABECMA: false,
              S11_TECVAYLI_Date: "", // Reset date for TECVAYLI
              S11_RRMM_TECVAYLI_RD: null, // Reset radio button for TECVAYLI
              S11_TALVEYTM_Date: "", // Reset date for TALVEYTM
              S11_RRMM_TALVEYTM_RD: null, // Reset radio button for TALVEYTM
              S11_ELREXFIOTM_Date: "", // Reset date for ELREXFIOTM
              S11_RRMM_ELREXFIOTM_RD: null, // Reset radio button for ELREXFIOTM
              S11_Linvoseltamab_Date: "", // Reset date for Linvoseltamab
              S11_RRMM_Linvoseltamab_RD: null, // Reset radio button for Linvoseltamab
              S11_CARVYKTI_Date: "", // Reset date for CARVYKTI
              S11_RRMM_CARVYKTI_RD: null, // Reset radio button for CARVYKTI
              S11_ABECMA_Date: "", // Reset date for ABECMA
              S11_RRMM_ABECMA_RD: null, // Reset radio button for ABECMA
              S11_RRMM_ABECMA_rb: null,
              S11_RRMM_CARVYKTI_rb: null,
              S11_RRMM_ELREXFIOTM_rb: null,
              S11_RRMM_Linvoseltamab_rb: null,
              S11_RRMM_TECVAYLI_rb: null,
              S11_RRMM_TALVEYTM_rb: null,
            };

            UpdateRRMMSoftErrors(next);
            return next;
          });
        } else {
          setCriteriaRRMM((prev) => {
            const next = {
              ...prev,
              [name]: value_int,
            };

            UpdateRRMMSoftErrors(next);
            return next;
          });
        }

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11AbeInvalidDate: false,
          s11CarInvalidDate: false,
          s11ElrInvalidDate: false,
          s11LinInvalidDate: false,
          s11TalInvalidDate: false,
          s11TecInvalidDate: false,
          s11TecRb: false,
          s11TalRb: false,
          s11ElrRb: false,
          s11LinRb: false,
          s11CarRb: false,
          s11AbeRb: false,
        }));

        break;
      }

      case "S11_RRMM_TECVAYLI": {
        const isTecvayliChecked = !criteriaRRMM.S11_RRMM_TECVAYLI;

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: isTecvayliChecked,
            S11_TECVAYLI_Date: isTecvayliChecked ? prev.S11_TECVAYLI_Date : "", // Reset date if unchecked
            S11_RRMM_TECVAYLI_RD: isTecvayliChecked
              ? prev.S11_RRMM_TECVAYLI_RD
              : null, // Reset radio button if unchecked
            S11_RRMM_NOTA: null,
            S11_TECVAYLI_Date_ValidError: false,
            S11_RRMM_TECVAYLI_rb: isTecvayliChecked
              ? prev.S11_RRMM_TECVAYLI_rb
              : null,
          };

          // Update soft errors centrally
          UpdateRRMMSoftErrors(next);

          return next;
        });

        setTecyali_s11(isTecvayliChecked); // Toggle visibility of radio buttons
        setHardErrList((prev) => ({
          ...prev,
          s11EmptyDate: false,
          s11Empty: false,
          s11TecInvalidDate: false,
          s11TecRb: false,
        }));

        break;
      }

      case "S11_RRMM_TECVAYLI_RD": {
        const valueInt = Number(value);

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: valueInt, //value,
            S11_TECVAYLI_Date: "",
            S11_TECVAYLI_Date_ValidError: false,
          };

          // Update soft errors centrally
          UpdateRRMMSoftErrors(next);

          return next;
        });

        setTecyali_s11(true);
        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11TecInvalidDate: false,
        }));

        break;
      }

      case "S11_RRMM_TALVEYTM": {
        const isTalveytmChecked = !criteriaRRMM.S11_RRMM_TALVEYTM;

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: isTalveytmChecked,
            S11_TALVEYTM_Date: isTalveytmChecked ? "" : prev.S11_TALVEYTM_Date, // Reset date if unchecked
            S11_RRMM_TALVEYTM_RD: isTalveytmChecked
              ? null
              : prev.S11_RRMM_TALVEYTM_RD, // Reset radio button if unchecked
            S11_RRMM_NOTA: null,
            S11_TALVEYTM_Date_ValidError: false,
            S11_RRMM_TALVEYTM_rb: isTalveytmChecked
              ? prev.S11_RRMM_TALVEYTM_rb
              : null,
          };

          UpdateRRMMSoftErrors(next);

          return next;
        });

        setTalvey_s11(isTalveytmChecked); // Toggle visibility of radio buttons

        setHardErrList((prev) => ({
          ...prev,
          s11EmptyDate: false,
          s11Empty: false,
          s11TalInvalidDate: false,
          s11TalRb: false,
        }));

        break;
      }

      case "S11_RRMM_TALVEYTM_RD": {
        const valueInt = Number(value);

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: valueInt,
            S11_TALVEYTM_Date: "",
            S11_TALVEYTM_Date_ValidError: false,
          };

          UpdateRRMMSoftErrors(next);

          return next;
        });

        setTalvey_s11(true);

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11TalInvalidDate: false,
        }));

        break;
      }

      case "S11_RRMM_ELREXFIOTM": {
        const isElrexfiotmChecked = !criteriaRRMM.S11_RRMM_ELREXFIOTM;

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: isElrexfiotmChecked,
            S11_ELREXFIOTM_Date: isElrexfiotmChecked
              ? prev.S11_ELREXFIOTM_Date
              : "", // Reset date if unchecked
            S11_RRMM_ELREXFIOTM_RD: isElrexfiotmChecked
              ? prev.S11_RRMM_ELREXFIOTM_RD
              : null, // Reset radio button if unchecked
            S11_RRMM_NOTA: null,
            S11_ELREXFIOTM_Date_ValidError: false,
            S11_RRMM_ELREXFIOTM_rb: isElrexfiotmChecked
              ? prev.S11_RRMM_ELREXFIOTM_rb
              : null,
          };

          UpdateRRMMSoftErrors(next);

          return next;
        });

        setElrexfio_s11(isElrexfiotmChecked); // Toggle visibility of radio buttons

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11ElrInvalidDate: false,
          s11ElrRb: false,
        }));

        break;
      }

      case "S11_RRMM_ELREXFIOTM_RD": {
        const valueInt = Number(value);

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: valueInt,
            S11_ELREXFIOTM_Date: "",
            S11_ELREXFIOTM_Date_ValidError: false,
          };

          UpdateRRMMSoftErrors(next);

          return next;
        });

        setElrexfio_s11(true);

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11ElrInvalidDate: false,
        }));

        break;
      }

      case "S11_RRMM_Linvoseltamab": {
        const isLinvoseltamabChecked = !criteriaRRMM.S11_RRMM_Linvoseltamab;

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: isLinvoseltamabChecked,
            S11_Linvoseltamab_Date: isLinvoseltamabChecked
              ? ""
              : prev.S11_Linvoseltamab_Date, // Reset date if unchecked
            S11_RRMM_Linvoseltamab_RD: isLinvoseltamabChecked
              ? null
              : prev.S11_RRMM_Linvoseltamab_RD, // Reset radio button if unchecked
            S11_RRMM_NOTA: null,
            S11_Linvoseltamab_Date_ValidError: false,
            S11_RRMM_Linvoseltamab_rb: isLinvoseltamabChecked
              ? prev.S11_RRMM_Linvoseltamab_rb
              : null,
          };

          UpdateRRMMSoftErrors(next);
          return next;
        });

        setLinvoseltamab_s11(isLinvoseltamabChecked);

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11LinInvalidDate: false,
          s11LinRb: false,
        }));

        break;
      }

      case "S11_RRMM_Linvoseltamab_RD": {
        const valueInt = Number(value);

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: valueInt,
            S11_Linvoseltamab_Date: "",
            S11_Linvoseltamab_Date_ValidError: false,
          };

          UpdateRRMMSoftErrors(next);
          return next;
        });

        setLinvoseltamab_s11(true);

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11LinInvalidDate: false,
        }));

        break;
      }

      case "S11_RRMM_CARVYKTI": {
        const isCarvyktiChecked = !criteriaRRMM.S11_RRMM_CARVYKTI;

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: isCarvyktiChecked,
            S11_CARVYKTI_Date: isCarvyktiChecked ? "" : prev.S11_CARVYKTI_Date, // Reset date if unchecked
            S11_RRMM_CARVYKTI_RD: isCarvyktiChecked
              ? null
              : prev.S11_RRMM_CARVYKTI_RD, // Reset radio button if unchecked
            S11_RRMM_NOTA: null,
            S11_CARVYKTI_Date_ValidError: false,
            S11_RRMM_CARVYKTI_rb: isCarvyktiChecked
              ? prev.S11_RRMM_CARVYKTI_rb
              : null,
          };

          UpdateRRMMSoftErrors(next);
          return next;
        });

        setCarvykti_s11(isCarvyktiChecked);

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11CarInvalidDate: false,
          s11CarRb: false,
        }));

        break;
      }

      case "S11_RRMM_CARVYKTI_RD": {
        const valueInt = Number(value);

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: valueInt,
            S11_CARVYKTI_Date: "",
            S11_CARVYKTI_Date_ValidError: false,
          };

          UpdateRRMMSoftErrors(next);
          return next;
        });

        setCarvykti_s11(true);

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11CarInvalidDate: false,
        }));

        break;
      }

      case "S11_RRMM_ABECMA": {
        const isAbecmaChecked = !criteriaRRMM.S11_RRMM_ABECMA;

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: isAbecmaChecked,
            S11_ABECMA_Date: isAbecmaChecked ? "" : prev.S11_ABECMA_Date, // Reset date if unchecked
            S11_RRMM_ABECMA_RD: isAbecmaChecked
              ? null
              : prev.S11_RRMM_ABECMA_RD, // Reset radio button if unchecked
            S11_RRMM_NOTA: null,
            S11_ABECMA_Date_ValidError: false,
            S11_RRMM_ABECMA_rb: isAbecmaChecked
              ? null
              : prev.S11_RRMM_ABECMA_rb,
          };

          UpdateRRMMSoftErrors(next);
          return next;
        });

        setAbecma_s11(isAbecmaChecked);

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11AbeInvalidDate: false,
          s11AbeRb: false,
        }));

        break;
      }

      case "S11_RRMM_ABECMA_RD": {
        const valueInt = Number(value);

        setCriteriaRRMM((prev) => {
          const next = {
            ...prev,
            [name]: valueInt,
            S11_ABECMA_Date: "",
            S11_ABECMA_Date_ValidError: false,
          };

          UpdateRRMMSoftErrors(next);
          return next;
        });

        setAbecma_s11(true);

        setHardErrList((prev) => ({
          ...prev,
          s11Empty: false,
          s11EmptyDate: false,
          s11AbeInvalidDate: false,
        }));

        break;
      }

      case "S11_RRMM_TECVAYLI_rb":
      case "S11_RRMM_TALVEYTM_rb":
      case "S11_RRMM_ELREXFIOTM_rb":
      case "S11_RRMM_Linvoseltamab_rb":
      case "S11_RRMM_CARVYKTI_rb":
      case "S11_RRMM_ABECMA_rb":
        const radionBtnValue = parseInt(value);

        setCriteriaRRMM((prev) => {
          const nextCriteria = {
            ...criteriaRRMM,
            [name]: radionBtnValue,
          };

          UpdateRRMMSoftErrors(nextCriteria);
          return nextCriteria;
        });

        setHardErrList((prev) => ({
          ...prev,
          ...(name === "S11_RRMM_TECVAYLI_rb" && { s11TecRb: false }),
          ...(name === "S11_RRMM_TALVEYTM_rb" && { s11TalRb: false }),
          ...(name === "S11_RRMM_ELREXFIOTM_rb" && { s11ElrRb: false }),
          ...(name === "S11_RRMM_Linvoseltamab_rb" && { s11LinRb: false }),
          ...(name === "S11_RRMM_CARVYKTI_rb" && { s11CarRb: false }),
          ...(name === "S11_RRMM_ABECMA_rb" && { s11AbeRb: false }),
        }));

        break;

      default:
        break;
    }
  };

  const ValidatePatientAgeForCohort = (criteria, indexDate) => {
    if (!criteria.s4_birth_date || !indexDate) {
      return false;
    }

    const age = CalculateAge(criteria.s4_birth_date, indexDate);
    return age < 18;
  };

  const DateInRange = (date, minDate, maxDate) => {
    return dayjs(date).isAfter(minDate) && dayjs(date).isBefore(maxDate);
  };

  const ValidateForm = () => {
    let isValid = true;
    if (
      (criteriaRRMM.S11_RRMM_NOTA === null ||
        criteriaRRMM.S11_RRMM_NOTA === false) &&
      !criteriaRRMM.S11_RRMM_TECVAYLI &&
      !criteriaRRMM.S11_RRMM_TALVEYTM &&
      !criteriaRRMM.S11_RRMM_ELREXFIOTM &&
      !criteriaRRMM.S11_RRMM_Linvoseltamab &&
      !criteriaRRMM.S11_RRMM_CARVYKTI &&
      !criteriaRRMM.S11_RRMM_ABECMA
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11Empty: true,
      }));
      isValid = false;
    }

    //Validation for radio button

    if (isNewEcrfA) {
      if (
        criteriaRRMM.S11_RRMM_TECVAYLI &&
        criteriaRRMM.S11_RRMM_TECVAYLI_rb == null
      ) {
        setHardErrList((p) => ({ ...p, s11TecRb: true }));
        isValid = false;
      }

      if (
        criteriaRRMM.S11_RRMM_TALVEYTM &&
        criteriaRRMM.S11_RRMM_TALVEYTM_rb == null
      ) {
        setHardErrList((p) => ({ ...p, s11TalRb: true }));
        isValid = false;
      }

      if (
        criteriaRRMM.S11_RRMM_ELREXFIOTM &&
        criteriaRRMM.S11_RRMM_ELREXFIOTM_rb == null
      ) {
        setHardErrList((p) => ({ ...p, s11ElrRb: true }));
        isValid = false;
      }

      if (
        criteriaRRMM.S11_RRMM_Linvoseltamab &&
        criteriaRRMM.S11_RRMM_Linvoseltamab_rb == null
      ) {
        setHardErrList((p) => ({ ...p, s11LinRb: true }));
        isValid = false;
      }

      if (
        criteriaRRMM.S11_RRMM_CARVYKTI &&
        criteriaRRMM.S11_RRMM_CARVYKTI_rb == null
      ) {
        setHardErrList((p) => ({ ...p, s11CarRb: true }));
        isValid = false;
      }

      if (
        criteriaRRMM.S11_RRMM_ABECMA &&
        criteriaRRMM.S11_RRMM_ABECMA_rb == null
      ) {
        setHardErrList((p) => ({ ...p, s11AbeRb: true }));
        isValid = false;
      }
    }

    if (
      (criteriaRRMM.S11_RRMM_TECVAYLI &&
        criteriaRRMM.S11_RRMM_TECVAYLI_RD === null) ||
      (criteriaRRMM.S11_RRMM_TALVEYTM &&
        criteriaRRMM.S11_RRMM_TALVEYTM_RD === null) ||
      (criteriaRRMM.S11_RRMM_ELREXFIOTM &&
        criteriaRRMM.S11_RRMM_ELREXFIOTM_RD === null) ||
      (criteriaRRMM.S11_RRMM_Linvoseltamab &&
        criteriaRRMM.S11_RRMM_Linvoseltamab_RD === null) ||
      (criteriaRRMM.S11_RRMM_CARVYKTI &&
        criteriaRRMM.S11_RRMM_CARVYKTI_RD === null) ||
      (criteriaRRMM.S11_RRMM_ABECMA && criteriaRRMM.S11_RRMM_ABECMA_RD === null)
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11EmptyDate: true,
      }));
      isValid = false;
    }

    if (
      (criteriaRRMM.S11_RRMM_TECVAYLI &&
        criteriaRRMM.S11_RRMM_TECVAYLI_RD === 1 &&
        (criteriaRRMM.S11_TECVAYLI_Date === null ||
          criteriaRRMM.S11_TECVAYLI_Date === "")) ||
      (criteriaRRMM.S11_RRMM_TALVEYTM &&
        criteriaRRMM.S11_RRMM_TALVEYTM_RD === 1 &&
        (criteriaRRMM.S11_TALVEYTM_Date === null ||
          criteriaRRMM.S11_TALVEYTM_Date === "")) ||
      (criteriaRRMM.S11_RRMM_ELREXFIOTM &&
        criteriaRRMM.S11_RRMM_ELREXFIOTM_RD === 1 &&
        (criteriaRRMM.S11_ELREXFIOTM_Date === null ||
          criteriaRRMM.S11_ELREXFIOTM_Date === "")) ||
      (criteriaRRMM.S11_RRMM_Linvoseltamab &&
        criteriaRRMM.S11_RRMM_Linvoseltamab_RD === 1 &&
        (criteriaRRMM.S11_Linvoseltamab_Date === null ||
          criteriaRRMM.S11_Linvoseltamab_Date === "")) ||
      (criteriaRRMM.S11_RRMM_CARVYKTI &&
        criteriaRRMM.S11_RRMM_CARVYKTI_RD === 1 &&
        (criteriaRRMM.S11_CARVYKTI_Date === null ||
          criteriaRRMM.S11_CARVYKTI_Date === "")) ||
      (criteriaRRMM.S11_RRMM_ABECMA &&
        criteriaRRMM.S11_RRMM_ABECMA_RD === 1 &&
        (criteriaRRMM.S11_ABECMA_Date === null ||
          criteriaRRMM.S11_ABECMA_Date === ""))
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11EmptyDate: true,
      }));
      isValid = false;
    }

    //Techvayli
    if (
      criteriaRRMM.S11_RRMM_TECVAYLI &&
      criteriaRRMM.S11_RRMM_TECVAYLI_RD === 1 &&
      (criteriaRRMM.S11_TECVAYLI_Date !== null ||
        criteriaRRMM.S11_TECVAYLI_Date !== "") &&
      criteriaRRMM.S11_TECVAYLI_Date === "Invalid Date"
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11TecInvalidDate: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_TECVAYLI &&
      criteriaRRMM.S11_RRMM_TECVAYLI_RD === 1 &&
      (criteriaRRMM.S11_TECVAYLI_Date !== null ||
        criteriaRRMM.S11_TECVAYLI_Date !== "") &&
      criteriaRRMM.S11_TECVAYLI_Date &&
      !DateInRange(criteriaRRMM.S11_TECVAYLI_Date, dayjs("01-01-1920"), dayjs())
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11TecInvalidDate: true,
      }));
      isValid = false;
    }

    //Talvey
    if (
      criteriaRRMM.S11_RRMM_TALVEYTM &&
      criteriaRRMM.S11_RRMM_TALVEYTM_RD === 1 &&
      (criteriaRRMM.S11_TALVEYTM_Date !== null ||
        criteriaRRMM.S11_TALVEYTM_Date !== null) &&
      criteriaRRMM.S11_TALVEYTM_Date === "Invalid Date"
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11TalInvalidDate: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_TALVEYTM &&
      criteriaRRMM.S11_RRMM_TALVEYTM_RD === 1 &&
      (criteriaRRMM.S11_TALVEYTM_Date !== null ||
        criteriaRRMM.S11_TALVEYTM_Date !== null) &&
      criteriaRRMM.S11_TALVEYTM_Date &&
      !DateInRange(criteriaRRMM.S11_TALVEYTM_Date, dayjs("01-01-1920"), dayjs())
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11TalInvalidDate: true,
      }));
      isValid = false;
    }

    //Elexfrio
    if (
      criteriaRRMM.S11_RRMM_ELREXFIOTM &&
      criteriaRRMM.S11_RRMM_ELREXFIOTM_RD === 1 &&
      criteriaRRMM.S11_ELREXFIOTM_Date != null &&
      criteriaRRMM.S11_ELREXFIOTM_Date != "" &&
      criteriaRRMM.S11_ELREXFIOTM_Date === "Invalid Date"
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11ElrInvalidDate: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_ELREXFIOTM &&
      criteriaRRMM.S11_RRMM_ELREXFIOTM_RD === 1 &&
      criteriaRRMM.S11_ELREXFIOTM_Date != null &&
      criteriaRRMM.S11_ELREXFIOTM_Date != "" &&
      criteriaRRMM.S11_ELREXFIOTM_Date &&
      !DateInRange(
        criteriaRRMM.S11_ELREXFIOTM_Date,
        dayjs("01-01-1920"),
        dayjs(),
      )
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11ElrInvalidDate: true,
      }));
      isValid = false;
    }

    //Linvoseltamab
    if (
      criteriaRRMM.S11_RRMM_Linvoseltamab &&
      criteriaRRMM.S11_RRMM_Linvoseltamab_RD === 1 &&
      criteriaRRMM.S11_Linvoseltamab_Date !== null &&
      criteriaRRMM.S11_Linvoseltamab_Date !== "" &&
      criteriaRRMM.S11_Linvoseltamab_Date === "Invalid Date"
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11LinInvalidDate: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_Linvoseltamab &&
      criteriaRRMM.S11_RRMM_Linvoseltamab_RD === 1 &&
      criteriaRRMM.S11_Linvoseltamab_Date !== null &&
      criteriaRRMM.S11_Linvoseltamab_Date !== "" &&
      criteriaRRMM.S11_Linvoseltamab_Date &&
      !DateInRange(
        criteriaRRMM.S11_Linvoseltamab_Date,
        dayjs("01-01-1920"),
        dayjs(),
      )
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11LinInvalidDate: true,
      }));
      isValid = false;
    }

    //Carvykti
    if (
      criteriaRRMM.S11_RRMM_CARVYKTI &&
      criteriaRRMM.S11_RRMM_CARVYKTI_RD === 1 &&
      criteriaRRMM.S11_CARVYKTI_Date !== null &&
      criteriaRRMM.S11_CARVYKTI_Date !== "" &&
      criteriaRRMM.S11_CARVYKTI_Date === "Invalid Date"
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11CarInvalidDate: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_CARVYKTI &&
      criteriaRRMM.S11_RRMM_CARVYKTI_RD === 1 &&
      criteriaRRMM.S11_CARVYKTI_Date !== null &&
      criteriaRRMM.S11_CARVYKTI_Date !== "" &&
      criteriaRRMM.S11_CARVYKTI_Date &&
      !DateInRange(criteriaRRMM.S11_CARVYKTI_Date, dayjs("01-01-1920"), dayjs())
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11CarInvalidDate: true,
      }));
      isValid = false;
    }

    //Abecma
    if (
      criteriaRRMM.S11_RRMM_ABECMA &&
      criteriaRRMM.S11_RRMM_ABECMA_RD === 1 &&
      criteriaRRMM.S11_ABECMA_Date !== null &&
      criteriaRRMM.S11_ABECMA_Date !== "" &&
      criteriaRRMM.S11_ABECMA_Date === "Invalid Date"
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11AbeInvalidDate: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_ABECMA &&
      criteriaRRMM.S11_RRMM_ABECMA_RD === 1 &&
      criteriaRRMM.S11_ABECMA_Date !== null &&
      criteriaRRMM.S11_ABECMA_Date !== "" &&
      criteriaRRMM.S11_ABECMA_Date &&
      !DateInRange(criteriaRRMM.S11_ABECMA_Date, dayjs("01-01-1920"), dayjs())
    ) {
      setHardErrList((prev) => ({
        ...prev,
        s11AbeInvalidDate: true,
      }));
      isValid = false;
    }

    if (
      criteriaRRMM.S11_RRMM_TECVAYLI &&
      criteriaRRMM.S11_RRMM_TECVAYLI_RD === 1 &&
      (criteriaRRMM.S11_TECVAYLI_Date !== null ||
        criteriaRRMM.S11_TECVAYLI_Date !== "") &&
      criteriaRRMM.S11_TECVAYLI_Date_ValidError
    ) {
      setCriteriaRRMM((prev) => ({
        ...prev,
        S11_TECVAYLI_Date_ValidError: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_TALVEYTM &&
      criteriaRRMM.S11_RRMM_TALVEYTM_RD === 1 &&
      (criteriaRRMM.S11_TALVEYTM_Date !== null ||
        criteriaRRMM.S11_TALVEYTM_Date !== null) &&
      criteriaRRMM.S11_TALVEYTM_Date_ValidError
    ) {
      setCriteriaRRMM((prev) => ({
        ...prev,
        S11_TALVEYTM_Date_ValidError: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_ELREXFIOTM &&
      criteriaRRMM.S11_RRMM_ELREXFIOTM_RD === 1 &&
      criteriaRRMM.S11_ELREXFIOTM_Date != null &&
      criteriaRRMM.S11_ELREXFIOTM_Date != "" &&
      criteriaRRMM.S11_ELREXFIOTM_Date_ValidError
    ) {
      setCriteriaRRMM((prev) => ({
        ...prev,
        S11_ELREXFIOTM_Date_ValidError: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_Linvoseltamab &&
      criteriaRRMM.S11_RRMM_Linvoseltamab_RD === 1 &&
      criteriaRRMM.S11_Linvoseltamab_Date !== null &&
      criteriaRRMM.S11_Linvoseltamab_Date !== "" &&
      criteriaRRMM.S11_Linvoseltamab_Date_ValidError
    ) {
      setCriteriaRRMM((prev) => ({
        ...prev,
        S11_Linvoseltamab_Date_ValidError: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_CARVYKTI &&
      criteriaRRMM.S11_RRMM_CARVYKTI_RD === 1 &&
      criteriaRRMM.S11_CARVYKTI_Date !== null &&
      criteriaRRMM.S11_CARVYKTI_Date !== "" &&
      criteriaRRMM.S11_CARVYKTI_Date &&
      criteriaRRMM.S11_CARVYKTI_Date_ValidError
    ) {
      setCriteriaRRMM((prev) => ({
        ...prev,
        S11_CARVYKTI_Date_ValidError: true,
      }));
      isValid = false;
    } else if (
      criteriaRRMM.S11_RRMM_ABECMA &&
      criteriaRRMM.S11_RRMM_ABECMA_RD === 1 &&
      criteriaRRMM.S11_ABECMA_Date !== null &&
      criteriaRRMM.S11_ABECMA_Date !== "" &&
      criteriaRRMM.S11_ABECMA_Date_ValidError
    ) {
      setCriteriaRRMM((prev) => ({
        ...prev,
        S11_ABECMA_Date_ValidError: true,
      }));
      isValid = false;
    }
    setIsAllDataFilled(isValid);

    return isValid;
  };

  const SavePage = async (validate) => {
    try {
      setHardErrList(InitialHardErrList);
      ToggleLoader(true);

      let isValid = validate ? ValidateForm() : true;
      if (!isValid) {
        setShowTopErrMsg(true);
        ToggleLoader(false);
        return false;
      }
      setShowTopErrMsg(false);

      const storedData = GetLocalStorageData("CohortTreatment");

      let cohortTreatmentModelListt = [];
      if (storedData) {
        cohortTreatmentModelListt = JSON.parse(storedData);
      }
      // if (isValid) {
      //((criteriaRRMM.S11_RRMM_NOTA == 0 ||
      //    criteriaRRMM.S11_RRMM_NOTA == null) &&
      //    cohortTreatmentModelListt.length > 0) ||
      const eligibilityCriteriademographicModel = {
        patientId: pid,
        centerId: centerId,
        userId: GetLoggedInUserID(),
        cartTherapyTecvayli: criteriaRRMM.S11_RRMM_TECVAYLI === true ? 1 : 0,
        cartTherapyTalvey: criteriaRRMM.S11_RRMM_TALVEYTM === true ? 1 : 0,
        cartTherapyElrexfio: criteriaRRMM.S11_RRMM_ELREXFIOTM === true ? 1 : 0,
        cartTherapyLinvoseltamab:
          criteriaRRMM.S11_RRMM_Linvoseltamab === true ? 1 : 0,
        cartTherapyCarvykti: criteriaRRMM.S11_RRMM_CARVYKTI === true ? 1 : 0,
        cartTherapyAbecma: criteriaRRMM.S11_RRMM_ABECMA === true ? 1 : 0,
        cartTherapyNone: criteriaRRMM.S11_RRMM_NOTA,

        // Radio buttons
        abecmaReceived: criteriaRRMM.S11_RRMM_ABECMA_rb,
        telveyReceived: criteriaRRMM.S11_RRMM_TALVEYTM_rb,
        carvyktiReceived: criteriaRRMM.S11_RRMM_CARVYKTI_rb,
        tecvayliReceived: criteriaRRMM.S11_RRMM_TECVAYLI_rb,
        elrexfioReceived: criteriaRRMM.S11_RRMM_ELREXFIOTM_rb,
        lynozyficReceived: criteriaRRMM.S11_RRMM_Linvoseltamab_rb,

        indexdateCartTherapyTecvayli: criteriaRRMM.S11_TECVAYLI_Date,
        indexdateCartTherapyTecvayliUnk:
          criteriaRRMM.S11_RRMM_TECVAYLI_RD === 99 ? true : false,
        indexdateCartTherapyTalvey: criteriaRRMM.S11_TALVEYTM_Date,
        indexdateCartTherapyTalveyUnk:
          criteriaRRMM.S11_RRMM_TALVEYTM_RD === 99 ? true : false,
        indexdateCartTherapyElrexfio: criteriaRRMM.S11_ELREXFIOTM_Date,
        indexdateCartTherapyElrexfioUnk:
          criteriaRRMM.S11_RRMM_ELREXFIOTM_RD === 99 ? true : false,
        indexdateCartTherapyLinvoseltamab: criteriaRRMM.S11_Linvoseltamab_Date,
        indexdateCartTherapyLinvoseltamabUnk:
          criteriaRRMM.S11_RRMM_Linvoseltamab_RD === 99 ? true : false,
        indexdateCartTherapyCarvykti: criteriaRRMM.S11_CARVYKTI_Date,
        indexdateCartTherapyCarvyktiUnk:
          criteriaRRMM.S11_RRMM_CARVYKTI_RD === 99 ? true : false,
        indexdateCartTherapyAbecma: criteriaRRMM.S11_ABECMA_Date,
        indexdateCartTherapyAbecmaUnk:
          criteriaRRMM.S11_RRMM_ABECMA_RD === 99 ? true : false,
        cohortTreatmentModelList: [],
        metInclusionCriteria:
          ((criteriaRRMM.S11_RRMM_NOTA == 0 ||
            criteriaRRMM.S11_RRMM_NOTA == null) &&
            ((criteriaRRMM.S11_RRMM_TECVAYLI === true &&
              softErrList.s11TecTerminate == false) ||
              (criteriaRRMM.S11_RRMM_TALVEYTM === true &&
                softErrList.s11TalTerminate == false) ||
              (criteriaRRMM.S11_RRMM_ELREXFIOTM === true &&
                softErrList.s11ElrTerminate == false) ||
              (criteriaRRMM.S11_RRMM_Linvoseltamab === true &&
                softErrList.s11LinTerminate == false) ||
              (criteriaRRMM.S11_RRMM_CARVYKTI === true &&
                softErrList.s11CarTerminate == false) ||
              (criteriaRRMM.S11_RRMM_ABECMA === true &&
                softErrList.s11AbeTerminate == false))) ||
          (cohortTreatmentModelListt.length > 0 &&
            (criteriaRRMM.S11_RRMM_NOTA == 0 ||
              criteriaRRMM.S11_RRMM_NOTA == null) &&
            softErrList.s11TecTerminate == false &&
            softErrList.s11TalTerminate == false &&
            softErrList.s11ElrTerminate == false &&
            softErrList.s11LinTerminate == false &&
            softErrList.s11CarTerminate == false &&
            softErrList.s11AbeTerminate == false) ||
          ((criteriaRRMM.S11_RRMM_NOTA == 0 ||
            criteriaRRMM.S11_RRMM_NOTA == null) &&
            softErrList.s11TecTerminate == false &&
            softErrList.s11TalTerminate == false &&
            softErrList.s11ElrTerminate == false &&
            softErrList.s11LinTerminate == false &&
            softErrList.s11CarTerminate == false &&
            softErrList.s11AbeTerminate == false) ||
          (criteriaRRMM.S11_RRMM_NOTA == 1 &&
            cohortTreatmentModelListt.length > 0 &&
            cohortTreatmentModelListt.filter((c) => c.ndmm === true).length >=
              1 &&
            softErrList.s11Terminate == true) ||
          (cohortTreatmentModelListt.length > 0 &&
            cohortTreatmentModelListt.filter((c) => c.ndmm === true).length >=
              1 &&
            (criteriaRRMM.S11_RRMM_NOTA == 0 ||
              criteriaRRMM.S11_RRMM_NOTA == null) &&
            (softErrList.s11TecTerminate == true ||
              softErrList.s11TalTerminate == true ||
              softErrList.s11ElrTerminate == true ||
              softErrList.s11LinTerminate == true ||
              softErrList.s11CarTerminate == true ||
              softErrList.s11AbeTerminate == true))
            ? true
            : false,
        isValidated: validate,
        IsAdmin: IsAdmin(),
      };
      setIsEligible(eligibilityCriteriademographicModel.metInclusionCriteria);

      setCriteriaRRMM((prev) => ({
        ...prev,
        metInclusionCriteria:
          eligibilityCriteriademographicModel.metInclusionCriteria,
      }));
      if (pid > 0) {
        const response = await EligibilityCriteriaService.SaveRRMMCriteria(
          eligibilityCriteriademographicModel,
        );

        if (response.status !== HTTPResponse.OK) {
          if (response?.status === HTTPResponse.Unauthorized) {
            HandleSessionTimeout();
          } else {
            throw response.error;
          }
        } else {
          setSoftErrList(InitialSoftErrList);
          ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
          await LoadData();
          ToggleLoader(false);
          if (response?.data?.showDateChangeAffectAlert) {
            ShowAlertBox();
          }
          if (
            eligibilityCriteriademographicModel.metInclusionCriteria === true
          ) {
            if (isNewEcrfA && HasEligibleNonNdmmNonMonoTherapyCohort()) {
              // At least one cohort is received in combination
              navigatePaths.nextPage = "/RRMMComboTherapy";
            } else {
              navigatePaths.nextPage = "/ExclusionCriteria";
            }
          }
        }
      }
      return true;
      // }
    } catch (error) {
      ToggleLoader(false);
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };

  /* <summary>
      date: 24-08-2024
      Name: BV
      description: Show an alert message when other page(index date) could be affected
      <summary>*/
  const ShowAlertBox = async () => {
    const choice = await ShowActionPopUp(
      "Alert", //title
      CommonError_Msgs.DateChangeAlert, //message
      "Ok", //Confirm button text
      true,
    );
  };

  const HandleDateChange = (name, date) => {
    const nextCriteria = {
      ...criteriaRRMM,
      [name]: date,
    };

    switch (name) {
      case "S11_TECVAYLI_Date":
        nextCriteria.S11_RRMM_TECVAYLI_RD = 1;
        setTecyali_s11(false);
        break;

      case "S11_TALVEYTM_Date":
        nextCriteria.S11_RRMM_TALVEYTM_RD = 1;
        setTalvey_s11(false);
        break;

      case "S11_ELREXFIOTM_Date":
        nextCriteria.S11_RRMM_ELREXFIOTM_RD = 1;
        setElrexfio_s11(false);
        break;

      case "S11_Linvoseltamab_Date":
        nextCriteria.S11_RRMM_Linvoseltamab_RD = 1;
        setLinvoseltamab_s11(false);
        break;

      case "S11_CARVYKTI_Date":
        nextCriteria.S11_RRMM_CARVYKTI_RD = 1;
        setCarvykti_s11(false);
        break;

      case "S11_ABECMA_Date":
        nextCriteria.S11_RRMM_ABECMA_RD = 1;
        setAbecma_s11(false);
        break;

      default:
        break;
    }

    setCriteriaRRMM(nextCriteria);

    const parsedDate = new Date(date);
    const isValidDate =
      parsedDate instanceof Date && !isNaN(parsedDate.getTime());

    if (isValidDate) UpdateRRMMSoftErrors(nextCriteria);

    setHardErrList((prev) => ({
      ...prev,
      s11EmptyDate: false,
    }));
  };

  const IsCohortDateValid = (criteria, cohortDate, approvalDate) => {
    if (!cohortDate) return false;
    // FDA approval date check
    if (
      approvalDate &&
      checkEligibileCohortTreatment(cohortDate, approvalDate)
    ) {
      return false;
    }
    const { s4_birth_date, s4_MM_diagnosis_date, initiationDate1LTreatment } =
      criteria;

    // Date of birth ≤ date of initial MM diagnosis ≤ NDMM index date ≤ Bispecifics/CAR-T initiation date

    // DOB is mandatory
    if (!s4_birth_date) return false;

    const dateChain = [
      s4_birth_date,
      s4_MM_diagnosis_date,
      initiationDate1LTreatment,
      cohortDate,
    ].filter(Boolean);

    // Validate chronological order
    for (let i = 0; i < dateChain.length - 1; i++) {
      if (!IsLessOrEqual(dateChain[i], dateChain[i + 1])) {
        return false;
      }
    }
    return true;
  };

  const sidebar = document.getElementById("mySidebar");
  const main = document.getElementById("main");

  const toggleNav = () => {
    if (isSideMenuActive === true) {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
      setIsSideMenuActive(false);
    } else if (isSideMenuActive === false) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
      setIsSideMenuActive(true);
    }
  };

  useEffect(() => {
    const sidebar = document.getElementById("mySidebar");
    const main = document.getElementById("main");

    if (isSideMenuActive === true) {
      sidebar.style.width = "350px";
      main.style.marginLeft = "350px";
    } else {
      sidebar.style.width = "0";
      main.style.marginLeft = "0";
    }
  });
  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
          </div>
        </div>
      </section>
      <section className="main-survey-section">
        <div>
          <SideBarMenu activePageId={SideMenuItems.RRMMCriteria} />
          <>
            <button
              className={isSideMenuActive ? "openbtn" : "openbtn active"}
              // onclick="toggleNav()"
              onClick={() => toggleNav()}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>

          <div className="col-pad-left eligibiltylocked" id="main">
            <div className="survey-section-content">
              <div className="survey-section-content-header">
                <h4>RRMM CRITERIA</h4>
              </div>
              {!showTopErrMsg &&
                pid != 0 &&
                criteriaRRMM.metInclusionCriteria != null &&
                criteriaRRMM.metInclusionCriteria == false && (
                  <div className="clean-error">
                    <p>{EligibilityCriteria_Msgs.IneligiblePatient}</p>
                  </div>
                )}

              {showTopErrMsg && (
                <div className="clean-error ">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              <div
                className="survey-question-section"
                disabled={criteriaRRMM.eligibilityDisabled}
              >
                <div className="survey-question-content">
                  <div className="question-answer">
                    <div className="question-bot-sapce">
                      <div className="question question-weight">
                        <span>S11.</span>
                        <span className="quest-text-pad">
                          <span> Which, if any, of the following</span>{" "}
                          <span
                            className="modal-popup"
                            data-tooltip-id="encounterTip"
                            onClick={() => setShowHideHyperlinkModalS11(true)}
                          >
                            bispecific or CAR-T therapies
                          </span>
                          {showHideHyperlinkModalS11 && (
                            <InfoPopUp
                              description={hyperlinkTextS11}
                              OkClick={() =>
                                setShowHideHyperlinkModalS11(false)
                              }
                            />
                          )}{" "}
                          did this patient receive for the treatment of MM{" "}
                          <b>at your medical center</b>{" "}
                          <u>
                            <b>
                              in any subsequent lines of therapy (any line
                              except 1L)
                            </b>
                          </u>
                          ?
                          <br />
                          Please note that:
                          <br />
                          <span style={{ padding: "10px 0" }}>
                            Treatments can be received as monotherapy or as part
                            of a combination therapy.
                          </span>
                          <br />
                          <div className="mt-1 mb-1">
                            For Bispecific therapies:
                            <ul className="mt-2">
                              <li>
                                Patients{" "}
                                <u>
                                  <b>do not have</b>
                                </u>{" "}
                                to have completed the entire line of therapy to
                                be eligible (i.e., the treatment regimen can be
                                ongoing by the time of data abstraction or last
                                visit)
                              </li>
                              <li>
                                Patients{" "}
                                <u>
                                  <b>are not permitted</b>
                                </u>{" "}
                                to have received any part of therapy as part of
                                a clinical trial or expanded access program
                                (EAP)
                              </li>
                            </ul>
                          </div>
                          <div>
                            For CAR-T therapies:
                            <ul className="mt-2 mb-1">
                              <li>
                                Patients{" "}
                                <u>
                                  <b>are required</b>
                                </u>{" "}
                                to have received the CAR-T infusion.
                              </li>
                              <li>
                                Patients{" "}
                                <u>
                                  <b>are permitted</b>
                                </u>{" "}
                                to receive any part of the therapy as part of an
                                EAP but{" "}
                                <u>
                                  <b>are not permitted</b>
                                </u>{" "}
                                to receive any part of the therapy in a clinical
                                trial
                              </li>
                            </ul>
                          </div>
                          <span>
                            If a Bispecific therapy was used as bridging therapy
                            for CAR-T, this{" "}
                            <u>
                              <b>is not considered</b>
                            </u>{" "}
                            combination therapy. Please abstract this as a{" "}
                            <u>
                              <b>line of CAR-T therapy only</b>
                            </u>
                            ; the bispecific therapy should not be abstracted as
                            its own cohort nor as a combination agent for the
                            CAR-T therapy.
                          </span>
                        </span>
                      </div>
                      <div className="double-dig-answer mt-2">
                        <div className="">
                          <div className="long-text-option">
                            <input
                              type="checkbox"
                              id="S11_RRMM_TECVAYLI"
                              name="S11_RRMM_TECVAYLI"
                              checked={criteriaRRMM.S11_RRMM_TECVAYLI}
                              onChange={HandleFieldChange}
                            />
                            <label
                              htmlFor="S11_RRMM_TECVAYLI"
                              className="radio-text-padding"
                            >
                              TECVAYLI® (teclistamab-cqyv)
                            </label>
                          </div>
                          {criteriaRRMM.S11_RRMM_TECVAYLI && (
                            <div>
                              {isNewEcrfA && (
                                <div
                                  className="mb-1"
                                  style={{
                                    marginLeft: "28px",
                                    padding: "10px 20px",
                                  }}
                                >
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_TECVAYLI_recieved_monotherapy"
                                      name="S11_RRMM_TECVAYLI_rb"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_TECVAYLI_rb === 1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_TECVAYLI_recieved_monotherapy">
                                      <span className="radio-text-padding">
                                        Received as monotherapy
                                      </span>
                                    </label>
                                  </div>
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_TECVAYLI_recieved_combination"
                                      name="S11_RRMM_TECVAYLI_rb"
                                      value={2}
                                      checked={
                                        criteriaRRMM.S11_RRMM_TECVAYLI_rb === 2
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_TECVAYLI_recieved_combination">
                                      <span className="radio-text-padding">
                                        Received in combination with other
                                        agents
                                      </span>
                                    </label>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.s11TecRb}
                                    message={EligibilityCriteria_Msgs.S9}
                                  />
                                </div>
                              )}
                              <div
                                className="dependent-sub-section"
                                style={{
                                  backgroundColor: "#F6F6F6",
                                  marginLeft: "28px",
                                  padding: "10px 20px",
                                }}
                              >
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="mb-2">
                                      S12. Date of treatment initiation
                                    </label>
                                    <br />
                                    <input
                                      type="radio"
                                      id="S11_RRMM_TECVAYLI_RD"
                                      name="S11_RRMM_TECVAYLI_RD"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_TECVAYLI_RD === 1
                                      }
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      {/*<DateControl*/}
                                      {/*  ctrlId={"S11_TECVAYLI_Date"}*/}
                                      {/*  HandleDateChange={HandleDateChange}*/}
                                      {/*  defDate={tecvayli_s11}*/}
                                      {/*  optionId={1}*/}
                                      {/*  date={criteriaRRMM.S11_TECVAYLI_Date}*/}
                                      {/*                                  />*/}
                                      <DatePickerComponent
                                        ctrlId={"S11_TECVAYLI_Date"}
                                        HandleDateChange={HandleDateChange}
                                        minDate={dayjs("01-01-1920")}
                                        maxDate={dayjs()}
                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                        date={criteriaRRMM.S11_TECVAYLI_Date}
                                      />
                                    </span>
                                  </div>
                                  <div className="option-without-input">
                                    <input
                                      type="radio"
                                      id="S11_RRMM_TECVAYLI_RD_Unk"
                                      name="S11_RRMM_TECVAYLI_RD"
                                      value={99}
                                      checked={
                                        criteriaRRMM.S11_RRMM_TECVAYLI_RD === 99
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_RRMM_TECVAYLI_RD_Unk">
                                      <span className="radio-text-padding">
                                        Date of initiation unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={softErrList.s11TecTerminate}
                                  message={EligibilityCriteria_Msgs.INELIGIBLE}
                                />
                                <ErrorField
                                  show={
                                    criteriaRRMM.S11_TECVAYLI_Date_ValidError
                                  }
                                  message={
                                    EligibilityCriteria_Msgs.EndOfFollowUpValidationMsg
                                  }
                                />
                                <ErrorField
                                  show={hardErrList.s11TecInvalidDate}
                                  message={CommonError_Msgs.InvalidDate}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="">
                          <div className="long-text-option">
                            <input
                              type="checkbox"
                              id="S11_RRMM_TALVEYTM"
                              name="S11_RRMM_TALVEYTM"
                              checked={criteriaRRMM.S11_RRMM_TALVEYTM}
                              onChange={HandleFieldChange}
                            />
                            <label
                              htmlFor="S11_RRMM_TALVEYTM"
                              className="radio-text-padding"
                            >
                              TALVEY<sup className="supscript">TM</sup>{" "}
                              (talquetamab-tgvs)
                            </label>
                          </div>
                          {criteriaRRMM.S11_RRMM_TALVEYTM && (
                            <div>
                              {isNewEcrfA && (
                                <div
                                  className="mb-1"
                                  style={{
                                    marginLeft: "28px",
                                    padding: "10px 20px",
                                  }}
                                >
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_TALVEYTM_recieved_monotherapy"
                                      name="S11_RRMM_TALVEYTM_rb"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_TALVEYTM_rb === 1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_TALVEYTM_recieved_monotherapy">
                                      <span className="radio-text-padding">
                                        Received as monotherapy
                                      </span>
                                    </label>
                                  </div>
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_TALVEYTM_recieved_combination"
                                      name="S11_RRMM_TALVEYTM_rb"
                                      value={2}
                                      checked={
                                        criteriaRRMM.S11_RRMM_TALVEYTM_rb === 2
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_TALVEYTM_recieved_combination">
                                      <span className="radio-text-padding">
                                        Received in combination with other
                                        agents
                                      </span>
                                    </label>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.s11TalRb}
                                    message={EligibilityCriteria_Msgs.S9}
                                  />
                                </div>
                              )}
                              <div
                                className="dependent-sub-section"
                                style={{
                                  backgroundColor: "#F6F6F6",
                                  marginLeft: "28px",
                                  padding: "10px 20px",
                                }}
                              >
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="mb-2">
                                      S12. Date of treatment initiation
                                    </label>
                                    <br />
                                    <input
                                      type="radio"
                                      id="S11_RRMM_TALVEYTM_RD"
                                      name="S11_RRMM_TALVEYTM_RD"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_TALVEYTM_RD === 1
                                      }
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      {/*<DateControl*/}
                                      {/*  ctrlId={"S11_TALVEYTM_Date"}*/}
                                      {/*  HandleDateChange={HandleDateChange}*/}
                                      {/*  defDate={talvey_s11}*/}
                                      {/*  optionId={1}*/}
                                      {/*  date={criteriaRRMM.S11_TALVEYTM_Date}*/}
                                      {/*                                  />*/}
                                      <DatePickerComponent
                                        ctrlId={"S11_TALVEYTM_Date"}
                                        HandleDateChange={HandleDateChange}
                                        minDate={dayjs("01-01-1920")}
                                        maxDate={dayjs()}
                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                        date={criteriaRRMM.S11_TALVEYTM_Date}
                                      />
                                    </span>
                                  </div>
                                  <div className="option-without-input">
                                    <input
                                      type="radio"
                                      id="S11_RRMM_TALVEYTM_RD_Unk"
                                      name="S11_RRMM_TALVEYTM_RD"
                                      value={99}
                                      checked={
                                        criteriaRRMM.S11_RRMM_TALVEYTM_RD === 99
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_RRMM_TALVEYTM_RD_Unk">
                                      <span className="radio-text-padding">
                                        Date of initiation unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={softErrList.s11TalTerminate}
                                  message={EligibilityCriteria_Msgs.INELIGIBLE}
                                />
                                <ErrorField
                                  show={
                                    criteriaRRMM.S11_TALVEYTM_Date_ValidError
                                  }
                                  message={
                                    EligibilityCriteria_Msgs.EndOfFollowUpValidationMsg
                                  }
                                />
                                <ErrorField
                                  show={hardErrList.s11TalInvalidDate}
                                  message={CommonError_Msgs.InvalidDate}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="">
                          <div className="long-text-option">
                            <input
                              type="checkbox"
                              id="S11_RRMM_ELREXFIOTM"
                              name="S11_RRMM_ELREXFIOTM"
                              checked={criteriaRRMM.S11_RRMM_ELREXFIOTM}
                              onChange={HandleFieldChange}
                            />
                            <label
                              htmlFor="S11_RRMM_ELREXFIOTM"
                              className="radio-text-padding"
                            >
                              ELREXFIO<sup className="supscript">TM</sup>{" "}
                              (elranatamab-bcmm)
                            </label>
                          </div>
                          {criteriaRRMM.S11_RRMM_ELREXFIOTM && (
                            <div>
                              {isNewEcrfA && (
                                <div
                                  className="mb-1"
                                  style={{
                                    marginLeft: "28px",
                                    padding: "10px 20px",
                                  }}
                                >
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_ELREXFIOTM_recieved_monotherapy"
                                      name="S11_RRMM_ELREXFIOTM_rb"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_ELREXFIOTM_rb ===
                                        1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_ELREXFIOTM_recieved_monotherapy">
                                      <span className="radio-text-padding">
                                        Received as monotherapy
                                      </span>
                                    </label>
                                  </div>
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_ELREXFIOTM_recieved_combination"
                                      name="S11_RRMM_ELREXFIOTM_rb"
                                      value={2}
                                      checked={
                                        criteriaRRMM.S11_RRMM_ELREXFIOTM_rb ===
                                        2
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_ELREXFIOTM_recieved_combination">
                                      <span className="radio-text-padding">
                                        Received in combination with other
                                        agents
                                      </span>
                                    </label>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.s11ElrRb}
                                    message={EligibilityCriteria_Msgs.S9}
                                  />
                                </div>
                              )}
                              <div
                                className="dependent-sub-section"
                                style={{
                                  backgroundColor: "#F6F6F6",
                                  marginLeft: "28px",
                                  padding: "10px 20px",
                                }}
                              >
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="mb-2">
                                      S12. Date of treatment initiation
                                    </label>
                                    <br />
                                    <input
                                      type="radio"
                                      id="S11_RRMM_ELREXFIOTM_RD"
                                      name="S11_RRMM_ELREXFIOTM_RD"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_ELREXFIOTM_RD ===
                                        1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <span className="radio-text-padding">
                                      {/*<DateControl*/}
                                      {/*  ctrlId={"S11_ELREXFIOTM_Date"}*/}
                                      {/*  HandleDateChange={HandleDateChange}*/}
                                      {/*  defDate={elrexfio_s11}*/}
                                      {/*  optionId={1}*/}
                                      {/*  date={criteriaRRMM.S11_ELREXFIOTM_Date}*/}
                                      {/*                                  />*/}
                                      <DatePickerComponent
                                        ctrlId={"S11_ELREXFIOTM_Date"}
                                        HandleDateChange={HandleDateChange}
                                        minDate={dayjs("01-01-1920")}
                                        maxDate={dayjs()}
                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                        date={criteriaRRMM.S11_ELREXFIOTM_Date}
                                      />
                                    </span>
                                  </div>
                                  <div className="option-without-input">
                                    <input
                                      type="radio"
                                      id="S11_RRMM_ELREXFIOTM_RD_Unk"
                                      name="S11_RRMM_ELREXFIOTM_RD"
                                      value={99}
                                      checked={
                                        criteriaRRMM.S11_RRMM_ELREXFIOTM_RD ===
                                        99
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_RRMM_ELREXFIOTM_RD_Unk">
                                      <span className="radio-text-padding">
                                        Date of initiation unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={softErrList.s11ElrTerminate}
                                  message={EligibilityCriteria_Msgs.INELIGIBLE}
                                />

                                <ErrorField
                                  show={
                                    criteriaRRMM.S11_ELREXFIOTM_Date_ValidError
                                  }
                                  message={
                                    EligibilityCriteria_Msgs.EndOfFollowUpValidationMsg
                                  }
                                />
                                <ErrorField
                                  show={hardErrList.s11ElrInvalidDate}
                                  message={CommonError_Msgs.InvalidDate}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="">
                          <div className="long-text-option">
                            <input
                              type="checkbox"
                              id="S11_RRMM_Linvoseltamab"
                              name="S11_RRMM_Linvoseltamab"
                              checked={criteriaRRMM.S11_RRMM_Linvoseltamab}
                              onChange={HandleFieldChange}
                            />

                            <label
                              htmlFor="S11_RRMM_Linvoseltamab"
                              className="radio-text-padding"
                            >
                              LYNOZYFIC<sup>TM</sup> (linvoseltamab-gcpt)
                            </label>
                          </div>
                          {criteriaRRMM.S11_RRMM_Linvoseltamab && (
                            <div>
                              {isNewEcrfA && (
                                <div
                                  className="mb-1"
                                  style={{
                                    marginLeft: "28px",
                                    padding: "10px 20px",
                                  }}
                                >
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_LYNOZYFIC_recieved_monotherapy"
                                      name="S11_RRMM_Linvoseltamab_rb"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_Linvoseltamab_rb ===
                                        1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_LYNOZYFIC_recieved_monotherapy">
                                      <span className="radio-text-padding">
                                        Received as monotherapy
                                      </span>
                                    </label>
                                  </div>
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_LYNOZYFIC_recieved_combination"
                                      name="S11_RRMM_Linvoseltamab_rb"
                                      value={2}
                                      checked={
                                        criteriaRRMM.S11_RRMM_Linvoseltamab_rb ===
                                        2
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_LYNOZYFIC_recieved_combination">
                                      <span className="radio-text-padding">
                                        Received in combination with other
                                        agents
                                      </span>
                                    </label>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.s11LinRb}
                                    message={EligibilityCriteria_Msgs.S9}
                                  />
                                </div>
                              )}
                              <div
                                className="dependent-sub-section"
                                style={{
                                  backgroundColor: "#F6F6F6",
                                  marginLeft: "28px",
                                  padding: "10px 20px",
                                }}
                              >
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="mb-2">
                                      S12. Date of treatment initiation
                                    </label>
                                    <br />
                                    <input
                                      type="radio"
                                      id="S11_RRMM_Linvoseltamab_RD"
                                      name="S11_RRMM_Linvoseltamab_RD"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_Linvoseltamab_RD ===
                                        1
                                      }
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      <DatePickerComponent
                                        ctrlId={"S11_Linvoseltamab_Date"}
                                        HandleDateChange={HandleDateChange}
                                        minDate={dayjs("01-01-1920")}
                                        maxDate={dayjs()}
                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                        date={
                                          criteriaRRMM.S11_Linvoseltamab_Date
                                        }
                                      />
                                    </span>
                                  </div>
                                  <div className="option-without-input">
                                    <input
                                      type="radio"
                                      id="S11_RRMM_Linvoseltamab_RD_Unk"
                                      name="S11_RRMM_Linvoseltamab_RD"
                                      value={99}
                                      checked={
                                        criteriaRRMM.S11_RRMM_Linvoseltamab_RD ===
                                        99
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_RRMM_Linvoseltamab_RD_Unk">
                                      <span className="radio-text-padding">
                                        Date of initiation unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={softErrList.s11LinTerminate}
                                  message={EligibilityCriteria_Msgs.INELIGIBLE}
                                />
                                <ErrorField
                                  show={
                                    criteriaRRMM.S11_Linvoseltamab_Date_ValidError
                                  }
                                  message={
                                    EligibilityCriteria_Msgs.EndOfFollowUpValidationMsg
                                  }
                                />
                                <ErrorField
                                  show={hardErrList.s11LinInvalidDate}
                                  message={CommonError_Msgs.InvalidDate}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="">
                          <div className="long-text-option">
                            <input
                              type="checkbox"
                              id="S11_RRMM_CARVYKTI"
                              name="S11_RRMM_CARVYKTI"
                              checked={criteriaRRMM.S11_RRMM_CARVYKTI}
                              onChange={HandleFieldChange}
                            />

                            <label
                              htmlFor="S11_RRMM_CARVYKTI"
                              className="radio-text-padding"
                            >
                              CARVYKTI® (ciltacabtagene autoleucel)
                            </label>
                          </div>
                          {criteriaRRMM.S11_RRMM_CARVYKTI && (
                            <div>
                              {isNewEcrfA && (
                                <div
                                  className="mb-1"
                                  style={{
                                    marginLeft: "28px",
                                    padding: "10px 20px",
                                  }}
                                >
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_CARVYKTI_recieved_monotherapy"
                                      name="S11_RRMM_CARVYKTI_rb"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_CARVYKTI_rb === 1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_CARVYKTI_recieved_monotherapy">
                                      <span className="radio-text-padding">
                                        Received as monotherapy
                                      </span>
                                    </label>
                                  </div>
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_CARVYKTI_recieved_combination"
                                      name="S11_RRMM_CARVYKTI_rb"
                                      value={2}
                                      checked={
                                        criteriaRRMM.S11_RRMM_CARVYKTI_rb === 2
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label
                                      htmlFor="S11_CARVYKTI_recieved_combination"
                                      style={{ display: "contents" }}
                                    >
                                      <span className="radio-text-padding">
                                        Received in combination with other
                                        agents
                                      </span>
                                      <br />
                                      <span
                                        className="radio-text-padding"
                                        style={{ marginLeft: "12px" }}
                                      >
                                        (bridging therapy and lymphodepletion
                                        therapy are not considered part of
                                        combination therapy)
                                      </span>
                                    </label>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.s11CarRb}
                                    message={EligibilityCriteria_Msgs.S9}
                                  />
                                </div>
                              )}
                              <div
                                className="dependent-sub-section"
                                style={{
                                  backgroundColor: "#F6F6F6",
                                  marginLeft: "28px",
                                  padding: "10px 20px",
                                }}
                              >
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="mb-2">
                                      S12. Date of treatment initiation
                                    </label>
                                    <br />
                                    <input
                                      type="radio"
                                      id="S11_RRMM_CARVYKTI_RD"
                                      name="S11_RRMM_CARVYKTI_RD"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_CARVYKTI_RD === 1
                                      }
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      {/*<DateControl*/}
                                      {/*  ctrlId={"S11_CARVYKTI_Date"}*/}
                                      {/*  HandleDateChange={HandleDateChange}*/}
                                      {/*  defDate={carvykti_s11}*/}
                                      {/*  optionId={1}*/}
                                      {/*  date={criteriaRRMM.S11_CARVYKTI_Date}*/}
                                      {/*                                  />*/}
                                      <DatePickerComponent
                                        ctrlId={"S11_CARVYKTI_Date"}
                                        HandleDateChange={HandleDateChange}
                                        minDate={dayjs("01-01-1920")}
                                        maxDate={dayjs()}
                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                        date={criteriaRRMM.S11_CARVYKTI_Date}
                                      />
                                    </span>
                                  </div>
                                  <div className="option-without-input">
                                    <input
                                      type="radio"
                                      id="S11_RRMM_CARVYKTI_RD_Unk"
                                      name="S11_RRMM_CARVYKTI_RD"
                                      value={99}
                                      checked={
                                        criteriaRRMM.S11_RRMM_CARVYKTI_RD === 99
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_RRMM_CARVYKTI_RD_Unk">
                                      <span className="radio-text-padding">
                                        Date of initiation unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={softErrList.s11CarTerminate}
                                  message={EligibilityCriteria_Msgs.INELIGIBLE}
                                />
                                <ErrorField
                                  show={
                                    criteriaRRMM.S11_CARVYKTI_Date_ValidError
                                  }
                                  message={
                                    EligibilityCriteria_Msgs.EndOfFollowUpValidationMsg
                                  }
                                />
                                <ErrorField
                                  show={hardErrList.s11CarInvalidDate}
                                  message={CommonError_Msgs.InvalidDate}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="">
                          <div className="long-text-option">
                            <input
                              type="checkbox"
                              id="S11_RRMM_ABECMA"
                              name="S11_RRMM_ABECMA"
                              checked={criteriaRRMM.S11_RRMM_ABECMA}
                              onChange={HandleFieldChange}
                            />

                            <label
                              htmlFor="S11_RRMM_ABECMA"
                              className="radio-text-padding"
                            >
                              ABECMA® (idecabtagene vicleucel)
                            </label>
                          </div>
                          {criteriaRRMM.S11_RRMM_ABECMA && (
                            <div>
                              {isNewEcrfA && (
                                <div
                                  className="mb-1"
                                  style={{
                                    marginLeft: "28px",
                                    padding: "10px 20px",
                                  }}
                                >
                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_ABECMA_recieved_monotherapy"
                                      name="S11_RRMM_ABECMA_rb"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_ABECMA_rb === 1
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_ABECMA_recieved_monotherapy">
                                      <span className="radio-text-padding">
                                        Received as monotherapy
                                      </span>
                                    </label>
                                  </div>

                                  <div>
                                    <input
                                      type="radio"
                                      id="S11_ABECMA_recieved_combination"
                                      name="S11_RRMM_ABECMA_rb"
                                      value={2}
                                      checked={
                                        criteriaRRMM.S11_RRMM_ABECMA_rb === 2
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label
                                      htmlFor="S11_ABECMA_recieved_combination"
                                      style={{ display: "contents" }}
                                    >
                                      <span className="radio-text-padding">
                                        Received in combination with other
                                        agents
                                      </span>
                                      <br />
                                      <span
                                        className="radio-text-padding"
                                        style={{ marginLeft: "12px" }}
                                      >
                                        (bridging therapy and lymphodepletion
                                        therapy are not considered part of
                                        combination therapy)
                                      </span>
                                    </label>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.s11AbeRb}
                                    message={EligibilityCriteria_Msgs.S9}
                                  />
                                </div>
                              )}
                              <div
                                className="dependent-sub-section"
                                style={{
                                  backgroundColor: "#F6F6F6",
                                  marginLeft: "28px",
                                  padding: "10px 20px",
                                }}
                              >
                                <div className="">
                                  <div className="option-without-input">
                                    <label className="mb-2">
                                      S12. Date of treatment initiation
                                    </label>
                                    <br />
                                    <input
                                      type="radio"
                                      id="S11_RRMM_ABECMA_RD"
                                      name="S11_RRMM_ABECMA_RD"
                                      value={1}
                                      checked={
                                        criteriaRRMM.S11_RRMM_ABECMA_RD === 1
                                      }
                                      onChange={HandleFieldChange}
                                    />

                                    <span className="radio-text-padding">
                                      {/*<DateControl*/}
                                      {/*  ctrlId={"S11_ABECMA_Date"}*/}
                                      {/*  HandleDateChange={HandleDateChange}*/}
                                      {/*  defDate={abecma_s11}*/}
                                      {/*  optionId={1}*/}
                                      {/*  date={criteriaRRMM.S11_ABECMA_Date}*/}
                                      {/*/>*/}
                                      <DatePickerComponent
                                        ctrlId={"S11_ABECMA_Date"}
                                        HandleDateChange={HandleDateChange}
                                        minDate={dayjs("01-01-1920")}
                                        maxDate={dayjs()}
                                        locale="en" // current it is mm/dd/yyyy but for dd/mm/yyyy use "en-gb"
                                        date={criteriaRRMM.S11_ABECMA_Date}
                                      />
                                    </span>
                                  </div>
                                  <div className="option-without-input">
                                    <input
                                      type="radio"
                                      id="S11_RRMM_ABECMA_RD_Unk"
                                      name="S11_RRMM_ABECMA_RD"
                                      value={99}
                                      checked={
                                        criteriaRRMM.S11_RRMM_ABECMA_RD === 99
                                      }
                                      onChange={HandleFieldChange}
                                    />
                                    <label htmlFor="S11_RRMM_ABECMA_RD_Unk">
                                      <span className="radio-text-padding">
                                        Date of initiation unknown
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={softErrList.s11AbeTerminate}
                                  message={EligibilityCriteria_Msgs.INELIGIBLE}
                                />
                                <ErrorField
                                  show={criteriaRRMM.S11_ABECMA_Date_ValidError}
                                  message={
                                    EligibilityCriteria_Msgs.EndOfFollowUpValidationMsg
                                  }
                                />
                                <ErrorField
                                  show={hardErrList.s11AbeInvalidDate}
                                  message={CommonError_Msgs.InvalidDate}
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="">
                          <input
                            type="radio"
                            id="S11_RRMM_NOTA"
                            name="S11_RRMM_NOTA"
                            value={1}
                            checked={criteriaRRMM.S11_RRMM_NOTA === 1}
                            onChange={HandleFieldChange}
                          />
                          <label htmlFor="S11_RRMM_NOTA">
                            <span className="radio-text-padding">
                              None of the above treatments{" "}
                            </span>
                          </label>
                        </div>
                        <ErrorField
                          show={hardErrList.s11Empty}
                          message={EligibilityCriteria_Msgs.S11}
                        />

                        <ErrorField
                          show={hardErrList.s11EmptyDate}
                          message={EligibilityCriteria_Msgs.S11Date}
                        />
                        <ErrorField
                          show={softErrList.s11Terminate}
                          message={EligibilityCriteria_Msgs.INELIGIBLE}
                        />
                        <ErrorField
                          style={{ marginTop: "10px" }}
                          show={softErrList.initiationDateInvalid}
                          message={
                            EligibilityCriteria_Msgs.RRMMInitiationDateWarning
                          }
                        />
                        <ErrorField
                          style={{ marginTop: "10px" }}
                          show={softErrList.patientAgeError}
                          message={
                            EligibilityCriteria_Msgs.PatientUnder18Warning
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default RRMMCriteria;
